module.exports = __webpack_public_path__ + "49bc25ac957cd3d4f151cdc6be8eeca5.mp3";